import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icons as I } from '../pack-icons';

/**
 * FirstRunHero — empty-state hero shown when no schedule + no published posts.
 * checklist: [{ label, sub, done, cta, to?, onAction? }]
 */
export default function FirstRunHero({ checklist = [] }) {
  const { t } = useTranslation();
  const done = checklist.filter((c) => c.done).length;
  return (
    <>
      <section className="fr-hero">
        <div className="fr-hero-bg" />
        <div className="fr-hero-inner">
          <span className="pill pill-accent" style={{ marginBottom: 16 }}>
            <span className="dot" />{t('firstRunHero.startHere')}
          </span>
          <h2 className="fr-h">
            {t('firstRunHero.heroTitleLead')}<br />
            <span className="fr-h-ac">{t('firstRunHero.heroTitleAccent')}</span>
          </h2>
          <p className="fr-p">
            {t('firstRunHero.heroSubtitle')}
          </p>
          <div className="fr-cards">
            <Link to="/app/create" className="fr-card fr-card-primary">
              <span className="fr-card-ico"><I.sparkles size={18} /></span>
              <div className="fr-card-text">
                <h4>{t('firstRunHero.cardGenerateTitle')}</h4>
                <p>{t('firstRunHero.cardGenerateDesc')}</p>
              </div>
              <span className="fr-card-cta">
                <span>{t('firstRunHero.cardGenerateCta')}</span>
                <I.arrowRight size={13} />
              </span>
            </Link>
            <Link to="/app/plan" className="fr-card">
              <span className="fr-card-ico"><I.target size={16} /></span>
              <div className="fr-card-text">
                <h4>{t('firstRunHero.cardPlanTitle')}</h4>
                <p>{t('firstRunHero.cardPlanDesc')}</p>
              </div>
              <I.arrowRight size={13} className="fr-card-arr" />
            </Link>
            <Link to="/app/settings?tab=social" className="fr-card">
              <span className="fr-card-ico"><I.users size={16} /></span>
              <div className="fr-card-text">
                <h4>{t('firstRunHero.cardConnectTitle')}</h4>
                <p>{t('firstRunHero.cardConnectDesc')}</p>
              </div>
              <I.arrowRight size={13} className="fr-card-arr" />
            </Link>
          </div>
        </div>
      </section>

      {checklist.length > 0 && (
        <section className="card fr-checklist">
          <div className="fr-cl-head">
            <div>
              <div className="eyebrow"><span>{t('firstRunHero.setupEyebrow')}</span></div>
              <h3>{t('firstRunHero.setupProgress', { done, total: checklist.length })}</h3>
            </div>
            <div className="fr-cl-bar">
              <div className="fr-cl-bar-fill" style={{ width: ((done / checklist.length) * 100) + '%' }} />
            </div>
          </div>
          <div className="fr-cl-list">
            {checklist.map((c, i) => (
              <div key={i} className={`fr-cl-item ${c.done ? 'is-done' : ''}`}>
                <span className="fr-cl-check">
                  {c.done ? <I.check size={12} /> : <span className="dot" style={{ background: 'currentColor', opacity: 0.4 }} />}
                </span>
                <div className="fr-cl-text">
                  <div className="fr-cl-title">{c.label}</div>
                  <div className="fr-cl-sub">{c.sub}</div>
                </div>
                {!c.done && c.cta && (
                  c.to ? (
                    <Link to={c.to} className="btn btn-soft btn-sm">
                      {c.cta} <I.arrowRight size={11} />
                    </Link>
                  ) : (
                    <button className="btn btn-soft btn-sm" onClick={c.onAction} type="button">
                      {c.cta} <I.arrowRight size={11} />
                    </button>
                  )
                )}
                {c.done && (
                  <span className="pill pill-success" style={{ height: 22 }}>
                    <I.check size={10} />{t('firstRunHero.statusDone')}
                  </span>
                )}
              </div>
            ))}
          </div>
        </section>
      )}
    </>
  );
}
